import router from "@/router";
import { MODEL_ROUTE_OVERRIDES } from "@/config/modelRoutes";

/**
 * Возвращает route-объект для детальной страницы модели или null, если маршрут не существует.
 * Использует конвенцию {ModelName}Details; исключения объявлены в MODEL_ROUTE_OVERRIDES.
 *
 * @param {string} modelName - имя модели с бэкенда (например 'Order', 'Trip')
 * @param {number|string} id - идентификатор записи
 * @param {object} routeParams - дополнительные параметры для нестандартных маршрутов
 */
export function getModelRoute(modelName, id, routeParams = {}) {
  const routeOverride = MODEL_ROUTE_OVERRIDES[modelName];
  if (typeof routeOverride === "function") {
    return routeOverride(id, routeParams);
  }

  const routeName = routeOverride ?? `${modelName}Details`;
  if (!router.hasRoute(routeName)) return null;
  return { name: routeName, params: { id } };
}

/**
 * Возвращает маршрут карточки ТС с открытой вкладкой календаря.
 *
 * @param {number|string} vehicleId - идентификатор ТС
 */
export function getVehicleCalendarRoute(vehicleId) {
  return {
    name: "VehicleDetails",
    params: { id: vehicleId },
    query: { tab: "calendar" },
  };
}

/**
 * Открывает произвольный маршрут в новой вкладке браузера.
 *
 * @param {import('vue-router').RouteLocationRaw} routeOptions
 */
export function openRouteInNewTab(routeOptions) {
  const route = router.resolve(routeOptions);
  window.open(route.href, "_blank");
}

/**
 * Возвращает назад с умным фолбэком.
 *
 * @param {import('vue-router').Router} router
 * @param {string} fallbackName - имя маршрута для фолбэка (например 'Vehicles')
 * @param {RegExp} fallbackPattern - паттерн, которому должен соответствовать
 *                                   предыдущий маршрут чтобы считаться фолбэком.
 *                                   По умолчанию совпадает точно с корневым путём секции.
 */
export function goBackOrFallback(
  router,
  fallbackName,
  fallbackPattern,
  fallbackParams = {}
) {
  const previous = router.options.history.state.back;

  if (previous && fallbackPattern && fallbackPattern.test(previous)) {
    router.push({ name: fallbackName, params: fallbackParams });
    return;
  }

  if (previous) {
    router.back();
    return;
  }

  router.push({ name: fallbackName, params: fallbackParams });
}
